const checkboxColumn = {
  headerName: '',
  field: '',
  checkboxSelection: true,
  maxWidth: 68
};
export default {
  namespaced: true,
  state: {
    priceColumns: [
      checkboxColumn,
      {
        headerName: 'start_date',
        field: 'start_date',
        colId: 'start_date'
      },
      {
        headerName: 'end_date',
        field: 'end_date',
        colId: 'end_date'
      },
      {
        headerName: 'group',
        field: 'groups_names',
        colId: 'groups_names'
      },
      {
        headerName: 'package_nr',
        field: 'package_nr',
        colId: 'package_nr'
      },
      {
        headerName: 'wood',
        field: 'trees_names',
        colId: 'trees_names'
      },
      {
        headerName: 'quality',
        field: 'qualities_names',
        colId: 'qualities_names'
      },
      {
        headerName: 'impr',
        field: 'imprs_names',
        colId: 'imprs_names'
      },
      {
        headerName: 'profile',
        field: 'profiles_names',
        colId: 'profiles_names',
        width: 115
      },
      {
        headerName: 'humidity',
        field: 'humidity',
        colId: 'humidity',
        width: 115
      },
      {
        headerName: 'thickness_mm',
        field: 'thickness',
        colId: 'thickness',
        width: 130
      },
      {
        headerName: 'width_mm',
        field: 'width',
        colId: 'width',
        width: 115
      },
      {
        headerName: 'length_mm',
        field: 'length',
        colId: 'length',
        width: 115
      },
      {
        headerName: 'stock_addresses',
        field: 'stock_addresses_names',
        colId: 'stock_addresses_names',
        width: 115
      },
      {
        headerName: 'cost',
        field: 'price',
        colId: 'price',
        width: 80
      },
      {
        headerName: 'metric_type',
        field: 'metric_type',
        colId: 'metric_type',
        width: 115
      }
    ],
    scoreColumns: [
      checkboxColumn,
      {
        headerName: 'start_date',
        field: 'start_date',
        colId: 'start_date'
      },
      {
        headerName: 'end_date',
        field: 'end_date',
        colId: 'end_date'
      },
      {
        headerName: 'wood',
        field: 'trees_names',
        colId: 'trees_names'
      },
      {
        headerName: 'group',
        field: 'groups_names',
        colId: 'groups_names'
      },
      {
        headerName: 'profile',
        field: 'profiles_names',
        colId: 'profile_name',
        width: 115
      },
      {
        headerName: 'thickness_mm',
        field: 'thickness',
        colId: 'thickness',
        width: 130
      },
      {
        headerName: 'width_mm',
        field: 'width',
        colId: 'width',
        width: 115
      },
      {
        headerName: 'length_mm',
        field: 'length',
        colId: 'length',
        width: 115
      },
      {
        headerName: 'quality',
        field: 'qualities_names',
        colId: 'qualities_names',
        width: 115
      },
      {
        headerName: 'score',
        field: 'score',
        colId: 'score',
        width: 90
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/general/pricePolicy.js